import { useRef } from "react";
import { createPortal } from "react-dom";
import { useDismiss } from "../../lib/useDismiss.js";
import { useI18n } from "../../lib/useI18n.js";

interface Props {
  x: number;
  y: number;
  onClose: () => void;
  onCreate: () => void;
}

export function CalendarBackgroundMenu({ x, y, onClose, onCreate }: Props) {
  const { t } = useI18n();
  const menuRef = useRef<HTMLDivElement | null>(null);

  const style: React.CSSProperties = {
    position: "fixed",
    left: Math.min(x, window.innerWidth - 160),
    top: Math.min(y, window.innerHeight - 80),
    zIndex: 9999,
  };

  useDismiss(onClose, { capture: true }, menuRef);

  return createPortal(
    <div
      ref={menuRef}
      style={style}
      className="w-40 rounded-md border bg-card/75 text-card-foreground shadow-lg backdrop-blur-sm"
      onContextMenu={(e) => e.preventDefault()}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="py-1">
        <button
          onClick={() => { onClose(); onCreate(); }}
          className="w-full px-3 py-2 text-left text-sm hover:bg-accent/65 hover:text-accent-foreground"
        >
          {t("calendar.createTask")}
        </button>
      </div>
    </div>,
    document.body,
  );
}
